<div class="preloadStyleCommon loaderCust {{ customClass }}" [class.width-100]="fullWidth">
  <div class="spinner progress-book1">
    <div class="rect1"></div>
    <div class="rect2"></div>
    <div class="rect3"></div>
    <div class="rect4"></div>
    <div class="rect5"></div>
  </div>
  <div class="spinner-text" *ngIf="loaderMsg">
    {{ loaderMsg }}
  </div>
</div>
